import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { finalize, Observable, of } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { FeeChange } from '../../model/fee-change';
import { PropertyTaxFeeChangePreview } from '../../model/PropertyTaxFeeChangePreview';
import { EMPTY_PROPERTY_TAX_RENTAL_CHANGES_RESPONSE, PropertyTaxRentalChangesResponseModel } from '../../model/property-tax-rental-change';

@Injectable()
export class PropertyTaxFeeChangeService extends DataService<FeeChange> {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService
  ) {
    super(_client, _config, _messageService, FeeChange, _progressBar, 'property-tax-fee-change');
  }

  getPropertyTaxRentalChanges(propertyIds: string[]): Observable<PropertyTaxRentalChangesResponseModel> {
    if (!propertyIds || propertyIds.length === 0) {
      return of(EMPTY_PROPERTY_TAX_RENTAL_CHANGES_RESPONSE);
    }

    this._progressBar.start();
    return this._client
      .post<PropertyTaxRentalChangesResponseModel>(`${this.endpoint}/`, propertyIds)
      .pipe(finalize(() => this._progressBar.stop()));
  }

  previewPropertyTaxChanges(form: any): Observable<PropertyTaxFeeChangePreview> {
    return this.client.post<PropertyTaxFeeChangePreview>(`${this.endpoint}/preview-property-tax-changes`, JSON.stringify(form));
  }

  changePropertyTax(form: any): Observable<any> {
    return this.client.put(`${this.endpoint}/property-tax-changes`, JSON.stringify(form));
  }
}
